<!--行业 -->
<template>
    <div id="news-box">
        <!-- <Carousel></Carousel> -->
        <img style="width:100%;" src="@/assets/images/news/img4.png" alt="">
        <div class="news row flex center">
            <div class="container">
                <div class="operational flex bCenter">
                <div class="operational-left">
                    <img src="@/assets/images/news/img6.png" alt="">
                    <P>行业资讯</P>
                </div>
                <!-- <div class="operational-right flex middle">
                    <div class="more flex middle" @click="more_info('新闻')">
                    <el-link :underline="false">更多<img :src="require('assets/images/news/more.png')"></el-link>
                    </div>
                </div> -->
                </div>
                <div class="news-body flex bCenter">
                <!-- <router-link :to="$utils.goDetailPagePath(newsFirst.contentid)"  @click="goToDetails(newsFirst.contentid,newsFirst,0)" v-if="newsFirst"> -->
                <a :href="$constant.allHttpUrl.baseAddressUrl+$utils.goDetailPagePath(newsFirst.contentid)"  @click.prevent="goToDetails(newsFirst.contentid,newsFirst,0)" v-if="newsFirst">
                    <div class="news-body-left flex bCenetr info-details-new">
                        <img :src="fileUrl+newsFirst.coverImg" alt="">
                        <div class="news-detail">
                        <div class="news-title" :title="newsFirst.title">
                            {{ newsFirst.title | omitValue(46)}}
                        </div>
                        <p>
                            {{ newsFirst.summary | omitValue(216)}}
                        </p>
                        </div>
                    </div>
                </a>
                <div class="news-body-right flex bCenetr">
                    <ul>
                    <li class="flex bCenter info-details-new" v-for="(item,index) in  newsList.slice(1,4)" :key="index">
                        <!-- <router-link :to="$utils.goDetailPagePath(item.contentid)" @click.native="goToDetails(item.contentid,item,index+1)"> -->
                        <a :href="$constant.allHttpUrl.baseAddressUrl+$utils.goDetailPagePath(item.contentid)" @click.prevent="goToDetails(item.contentid,item,index+1)">
                            <div class="flex bCenter info-details-new">
                                <img :src="fileUrl+item.coverImg" alt="">
                                <div class="li-right">
                                <div class="news-title text-overflow" :title="item.title">
                                    {{ item.title }}
                                </div>
                                <p>
                                    {{ item.summary | omitValue(28)}}
                                </p>
                                </div>
                            </div>
                        </a>
                    </li>
                    </ul>
                </div>
                </div>
            </div>
        </div>
        <div class="new-list">
            <ul class="list">
                <!-- <li v-for="(item,index) in news" :key="index" @click="goDetail(item.contentid,item,index)"> -->
                <!-- <router-link :to="$utils.goDetailPagePath(item.contentid)" @click.native="goDetail(item.contentid,item,index)" v-for="(item,index) in news" :key="index" class="item"> -->
                <a :href="$constant.allHttpUrl.baseAddressUrl+$utils.goDetailPagePath(item.contentid)" @click.prevent="goDetail(item.contentid,item,index)" v-for="(item,index) in news" :key="index" class="item">
                    <p class="p1">{{item.title| omitValue(3)}}</p>
                    <span class="span2">{{item.publishTime}}</span>
                </a>
                <!-- </li> -->
            </ul>
            <div class="page">
                <pagination 
                    @current-change="pageChange"
                    :current-page.sync="paramsList.page"
                    :page-size="paramsList.rows"
                    layout="prev, pager, next, jumper"
                    :total="total">
                </pagination>
            </div>
        </div>
    </div>
</template>
<script>
import Carousel from 'components/Carousel/Carousel.vue';
import pagination from 'components/pagination/index.vue';
import * as api_news from "service/api/methods/api_news.js"; //接口
import metaInfoUtils from 'config/metaInfo.config.js';

export default {
    metaInfo: metaInfoUtils.currentMetaInfo('/news/industry'),
    components:{
        Carousel,pagination
    },
    data(){
        return{
            fileUrl:'',
            newsFirst:{},
            newsList:[],
            news:[],
            total:0,
            params:{
                typeid: 1,
                page: 1,
                rows:4,
                status: 1,
                isHome: 1,
            },
            paramsList:{
                typeid: 2,
                page: 1,
                rows: 10,
                status: 1,
            }
        }
    },
    created(){
        // this.getContentList(this.params);
        // this.getList(this.paramsList);
    },
    mounted(){
        this.getContentList(this.params);
        this.getList(this.paramsList);
    },
    methods:{
        pageChange(val){
            this.paramsList.page=val;
            this.getList(this.paramsList);
        },
        more_info(){},

        goDetail(contentid,item,index){
            let p={contentid:contentid,newsType:0,typeid:item.typeid,isHome:item.isHome,status:item.status,index:index,page:this.paramsList.page,rows:10};
            this.$storage.saveNewsDetailP(p);
            // this.$utils.goDetailPage(this.$router,contentid);
            this.$router.push({path:this.$utils.goDetailPagePath(contentid)});
        },
        goToDetails(contentid,item,index){
            let p={contentid:contentid,newsType:0,typeid:item.typeid,isHome:item.isHome,status:item.status,index:index,page:1,rows:4,maxTotal:4};
            this.$storage.saveNewsDetailP(p);
            // this.$utils.goDetailPage(this.$router,contentid);
            this.$router.push({path:this.$utils.goDetailPagePath(contentid)});
        },
        getContentList(p){
            api_news.getContentList(p).then((res)=>{
                this.fileUrl=res.baseUrl;
                this.newsList=res.data;
                this.newsFirst=res.data[0];
            }).catch(earr => {});
        },
        getList(p){
            api_news.getContentList(p).then((res)=>{
                this.news=res.data;
                this.total=res.total;
            }).catch(earr => {});
        }
    }
}
</script>
<style lang="less" scoped>
@import './industry.less';
</style>